'use client';

import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="pl">
      <body className="bg-gray-900 text-white flex items-center justify-center h-screen">
        <div className="text-center p-8 border border-gray-700 rounded-lg">
          <h2 className="text-2xl font-bold text-red-500 mb-4">Wystąpił błąd</h2>
          <p className="mb-6">Coś poszło nie tak. Spróbuj odświeżyć stronę.</p>
          <button
            onClick={reset}
            className="bg-gray-700 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded"
          >
            Odśwież
          </button>
        </div>
      </body>
    </html>
  );
}
